export const lottieFiles = {
  messageSent: require('./MessageSent.json'),
  sharePdf: require('./sharePDF.json'),
}
